import React from 'react'
import View from '../View'
import LeftSidebarView from '../LeftView'
import { useSelector } from 'react-redux'
import { useCardContext } from 'dataProviders/Card'
import KanBoIcon from 'components/KanBoIcon'
import ViewHeader from '../ViewHeader'

const CardModalView = React.forwardRef<View, React.ComponentPropsWithRef<typeof LeftSidebarView>>((props, ref) => {
  const { id } = useCardContext()

  const cardName = useSelector(state => state['view-board'].cards[id]?.name)

  return (
    <LeftSidebarView
      {...props}
      ref={ref}
      title={
        <ViewHeader
          icon={<KanBoIcon name='kanbo-16-card' />}
          header={cardName}
        >
          {props.title}
        </ViewHeader>
      }
    />
  )
})

export default CardModalView
